import * as React from "react";
import { useMemo, useState } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { RowContainer } from "components/lookup-tables/layout-componets";
import CacheForm from "./CacheForm";
import CacheTypeSelect from "./CacheTypeSelect";
const UseExistingButton = styled(Button)`
  margin-top: 1.57rem;
`;
function CacheFormView({ saved = void 0, onCancel, cache = void 0, isStep = false }) {
  var _a;
  const [lutCache, setLutCache] = useState(cache);
  const isCreate = useMemo(() => !(lutCache == null ? void 0 : lutCache.id), [lutCache]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isCreate && /* @__PURE__ */ React.createElement(RowContainer, null, /* @__PURE__ */ React.createElement(CacheTypeSelect, { cacheConfigType: lutCache ? lutCache.config.type : null, onCacheChange: setLutCache }), isStep && /* @__PURE__ */ React.createElement(UseExistingButton, { onClick: onCancel }, "Use Existing Cache")), lutCache && /* @__PURE__ */ React.createElement(
    CacheForm,
    {
      cache: lutCache,
      type: (_a = lutCache == null ? void 0 : lutCache.config) == null ? void 0 : _a.type,
      create: isCreate,
      title: "Configure Cache",
      saved,
      onCancel
    }
  ));
}
export default CacheFormView;
